import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { workOrderRecordQuery } from "@/app/ProDrivers/WorkOrders/GraphQL/workOrdersQuery";

export function useWorkOrder(workOrderId: string) {
  const { data } = useSuspenseGqlQuery(workOrderRecordQuery, {
    id: workOrderId,
  });

  if (!data.workOrder) {
    throw new Error("Work order not found");
  }

  return data.workOrder;
}
